import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('user-click-areas-showcase', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      const element = componentInfo.element;
      element.classList.add('user-click-areas-showcase');
      return new ViewModel(params, element);
    },
  },
  template: html,
});
